import React, { useEffect } from 'react'
import './Nuts.css'
import Notfound from '../../../../Notfound'
import Breadcrumb from '../../../../../components/Breadcrum';
import InfoContainer from '../../../../../components/InfoContainer';
import Card from '../../../../../components/Card';
const cardData = [
  {
    id: "Cashews",
    image: "./assets/img/agriculturalCommodities/cashews.png",
    title: "Cashews",
    redirectionUrl: '/business/agricultural-commodities/cashews',
  },
  {
    id: "Peanuts",
    image: './assets/img/agriculturalCommodities/peanuts.png',
    title: "Peanuts",
    redirectionUrl: '/business/agricultural-commodities/peanuts',
  }

];
export default function Nuts() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Nuts"
        backgroundImage='./assets/img/contact-banner.png'
        height="40vh"
      ></Breadcrumb>
      {/* <InfoContainer 
       title='Supercharge your health with all natural nutritions'
        paragraph1='Nuts are an antioxidant powerhouse which are becoming regular nutritional food to the modern household and growing in demand; especially coupled with population growth and globalization. Nurargro strives to meet the growing need for these products, all the while, maintaining an excellence in quality. We believe strongly in the products we trade, their nutritional benefits, and their role in making the world a healthier place.'
        paragraph2 ="Nuragro’s distinguishing factor lies in our effective management of the supply chain. Our procurement starts directly from the origin. In the mission to ensure that the highest quality product is delivered to our customers at competitive prices. The list of nuts dealt by Nuragro is as below,"
      /> */}

      <div className="cardContainer mt-5">
        <div className="container">
          <div className="row g-lg-5 g-4">
            {cardData.map((card) => (
              <div key={card.id} className="col-lg-4 col-md-6 col-12">
              <Card
                key={card.id}
                image={card.image}
                title={card.title}
                id={card.id}
                description={card.description}
                redirectionUrl={card.redirectionUrl}
              />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="greenbox container my-5">
        <div className="theme_facts">
          <h1>Facts on Peanut Nuts</h1>
          <p className="white">
            The peanut, also known as the groundnut and the goober and taxonomically classified as Arachis hypogaea, is a legume crop grown mainly for its edible seeds. It is widely grown in the tropics and subtropics, being important to both small and large commercial producers. It is classified as both a grain legume and, because of its high oil content, an oil crop. World annual production of shelled peanuts was 42 million tonnes in 2014. Atypically among crop plants, peanut pods develop underground rather than aboveground. It is this characteristic that the botanist Linnaeus used to assign the specific name hypogaea, which means "under the earth."
          </p>
          <p className="white">
            As a legume, the peanut belongs to the botanical family Fabaceae; this is also known as Leguminosae, and commonly known as the bean, or pea, family. Like most other legumes, peanuts harbor symbiotic nitrogen-fixing bacteria in root nodules. This capacity to fix nitrogen means peanuts require less nitrogen-containing fertilizer and improve soil fertility, making them valuable in crop rotations.
          </p>
          <p className="white">
            Peanuts are similar in taste and nutritional profile to tree nuts such as walnuts and almonds, and are often served in similar ways in Western cuisines. The botanical definition of a "nut" is a fruit whose ovary wall becomes very hard at maturity. Using this criterion, the peanut is not a true nut, but rather a legume. However, for culinary purposes and in common English language usage, peanuts are usually referred to as nuts.
          </p>
        </div>
      </div>
    </>

  )
}